/**
 * 経路の見た目を決めるチューニング定数。
 *
 * v1 (避難マップ) / v2 (災害時避難先) / シード焼き込みスクリプトが同じ値を使う。
 * 以前は autodraft.ts と MapCanvas.vue に同じ数値がベタ書きされ、コメントで
 * 「同値にすること」と申し合わせていた。
 *
 * このファイルは意図的に依存ゼロにしてある。autodraft.ts は Mapbox クライアント
 * 経由で `import.meta.env` (Vite 専用) に触れるため、node で動くビルドスクリプト
 * (scripts/bake-seeds.mjs) から import できない。定数だけをここに分けることで、
 * スクリプト側も同じ値を参照できる。
 */

/**
 * 経路の直線化トレランス (m)。大きいほど細かいガタガタを無視して直線的になる。
 * 「経路を正確に辿るとガタガタになる」ため、これで経路に沿った直線へ均す。
 * **スナップ前の生 Directions ポリライン専用**。スナップ済みの経路にこの値を使うと
 * 中心線に載せた頂点まで弦で切り、道路をはみ出す直線に戻す (下記参照)。
 */
export const ROUTE_SIMPLIFY_TOLERANCE_M = 12;

/**
 * 中心線スナップ済み経路の直線化トレランス (m)。スナップが済んだ形は既にスキーマ
 * ティックなので、残す/削る判断は「道からの視認できるずれ」の閾値でよい。
 * 12m を使うと snap で車道中心線に載せた頂点 (実測: 横浜 A1 の 8 点・脚長 32〜192m)
 * まで弦で切り落とし、332m の直線が街区を横断する 4 点の粗い線に潰れる — これが
 * 「スナップしたのに道路をはみ出す/飛び出す」の正体。2m なら弦の逸脱が道路帯の内側に
 * 収まり、直角の実在角も残る。
 * postprocessRoute (スナップ直後) と v1 表示パス (MapCanvas) の両方がこの値を使う。
 */
export const SNAPPED_SIMPLIFY_TOLERANCE_M = 2;

/** 矢印を避難先の入り口から内部へ入り込ませる距離 (m)。 */
export const DESTINATION_PENETRATION_M = 150;
